<template>
  <div>
    <CrudList
      title="Compra de Coins"
      storeName="Coin_purchases"
      label-show="Ver"    
      :canAdd="false"
      :canEdit="false"
      :canShow="true"
      :canDelete="true"
      :canExport="true"
      :filters="filters"   
      sortable
      next-link="/admin/coins"
      :breadcrumbs="[
        {
          text: 'Finanzas',
          disabled: false,
          href: '/admin/coin_purchases'
        },
        {
          text: 'Compra de coins',
          disabled: false,
          href: '#'
        }
      ]"
    >

    /* ----- HEADER FILTERS------------------------- */
    <template v-slot:head-list>
      <v-row>
        <v-col cols="3">
          <v-menu            
            v-model="menu_from"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y 
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                label="Desde"
                prepend-inner-icon="fas fa-calendar"                
                readonly
                :value="fromDateDisp"
                solo
                    hide-details="auto"
                    class="input-base"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              locale="en-in"
              v-model="date_from"
              no-title
              @input="menu_from = false"              
            ></v-date-picker>
          </v-menu>
        </v-col>
        
        <v-col cols="3">
          <v-menu            
            v-model="menu_to"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            
            offset-y 
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                label="Hasta"
                prepend-inner-icon="fas fa-calendar"  
                solo
                    hide-details="auto"
                    class="input-base"              
                readonly
                :value="toDateDisp"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              locale="en-in"
              v-model="date_to"
              no-title
              @input="menu_to = false"              
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
    </template>
    /* ----HEADER CELL------------------------------ */
    <template v-slot:name="{ item }">
      {{ item.user_id.name }}
    </template>
    <template v-slot:last_name="{ item }">
      {{ item.user_id.last_name }}
    </template>

    <template v-slot:date_approved="{ item }">
      {{ formatDate(item.date_approved) }}
    </template>
      <template v-slot:total_in_pesos="{ item }">
        <p class="mb-0 text-right text-no-wrap">
          {{
            formatUSD(
                Number(item.total_in_pesos) ||
                0 /* -
              calculateCommission(item.total, item.commission_percentage) */
            )
          }}
        </p>
      </template>
      <template v-slot:commission="{ item }">
        <p class="mb-0 text-right text-no-wrap">
          {{
            formatUSD(
                Number(item.commission) ||
                0 /* -
              calculateCommission(item.total, item.commission_percentage) */
            )
          }}
        </p>
      </template>
    </CrudList>
  </div>
</template>

<script>
  import CrudList from "@/components/Crud/CrudList";
  import moment from "moment";
  import CrudFormMixin from "@/mixins/crud_form";
  import {format} from "currency-formatter";

  export default {
    mixins: [CrudFormMixin],
    components: {CrudList},
    watch: {
      "date_from": {
        async handler(val) {
          this.filters.date_from = moment(val);
          this.filters.date_to = moment();
          await this.updateCoinPurchase();
        },    
      },
      "date_to": {
        async handler(val) {
          let set_date_to = moment();
          if(val)
            set_date_to = moment(val);

          this.filters.date_to = set_date_to;
          
          await this.updateCoinPurchase();          
        },    
      }
    },
    data() {
      return { 
        tmp_all_coin_purchases: {
          filters: {}
        },
        filters: {
          date_from: null,
          date_to: null
        },
        offsetTop: 0,
        menu_from: false,
        menu_to: false,        
        date_from: null,          
        date_to: null,
        data:{
          amount_acquired:'',
          current_amount:'',
          previous_amount:'',
          total_in_pesos:'',
          commission:'',
          date_approved:''
        }
      };
    },  
    
    methods: {
      onScroll (e) {
        this.offsetTop = e.target.scrollTop
      },
      async updateCoinPurchase() {
        if (
          JSON.stringify(this.filters) !==
          JSON.stringify(this.tmp_all_coin_purchases.filters)
        ) {
          const all_coin_purchases = await this.$store.dispatch(
            "Coin_purchases/getListAll",
            { show_all: "enable", ...this.filters }
          );
          
          this.tmp_all_coin_purchases.filters = { ...this.filters };
        }
      },
      formatUSD(value) {
        return format(Number(value).toFixed(2), {
          code: "USD",
          decimal: ",",
          thousand: ".",
          format: "%s %v",
        });
      },
    },
    computed: {      
      fromDateDisp() {
        return this.date_from;
      },
      toDateDisp() {
        return this.date_to;
      },
      
    }
  };
</script>
